<template>
    <div :style="styleDynamicElement(el)" :class="el.getAnimationClass(currentElementIndex)" @mousedown="eventDrag($event, el.previewId)">
        <div :style="el.getStyle(currentElementIndex)">
            <video :style="el.getVideoStyle()" :src="el.Path" autoplay loop muted></video>
        </div>
        <ShadowMedia v-if="el.Shadow" :el="el.Shadow"/>
    </div>
</template>

<script>
import BasePreviewComponents from "./base/basePreviewComponents.vue";
import ShadowMedia from "./shadow.vue";
export default {
    name: 'VideoMedia',
    extends: BasePreviewComponents,
    components: {
        ShadowMedia
    },
    methods: {
    }
}
</script>

<style scoped>
video {
    pointer-events: none;
}
</style>


